<svelte:head>
    <!-- Fonts -->
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap"
          rel="stylesheet">
    <link
            rel="stylesheet"
            href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,600,700"
    />

    <!-- Material Typography -->
    <link
            rel="stylesheet"
            href="https://unpkg.com/@material/typography@14.0.0/dist/mdc.typography.css"
    />

</svelte:head>
<script>
    import * as Tone from "tone";
    import {writable} from 'svelte/store';
    import LavaLogo from "./components/LavaLogo.svelte";
    import ToneLoader from "./components/ToneLoader.svelte";
    import StepSequencer from "./components/StepSequencer.svelte";
    import TonePlayToogle from "./components/TonePlayToogle.svelte";
    import {onMount} from "svelte";
    import ToneSlider from "./components/ToneSlider.svelte";
    import Samples from "./components/samples.js";
    import PatternList from "./components/patternList.js";
    import Loader from "./components/Loader.js"

    export let name;
    const patternList = PatternList()
    const samples = Samples();
    let urls;

    export const loaderStore = writable(null);
    let value = 120;
    let subdivision = "16n";

    onMount(async () => {
        const loader = new Loader();
        await loader.start();
        loaderStore.set(loader);
    });

    function getColumns(patternList) {
        return patternList[0].noteCount;
    }

    let columns = getColumns(patternList);

    function createTracks(patternList, samples) {
        const tracks = new Map();
        const patterns = patternList[0].patternList; // pick the first patternList
        patterns.forEach((pattern, index) => {
            const sampleKey = pattern.sample;
            if (samples.hasOwnProperty(sampleKey)) {
                tracks.set(index, samples[sampleKey].file);
            }
        });
        return tracks;
    }

    function reverseMap(map) {
        const reversedArray = Array.from(map.entries()).reverse();
        return new Map(reversedArray);
    }

    function createTitleList(patternList, samples) {
        const titles = new Map();
        const patterns = patternList[0].patternList; // pick the first patternList

        patterns.forEach((pattern, index) => {
            const sampleKey = pattern.sample;
            if (samples.hasOwnProperty(sampleKey)) {
                titles.set(index, samples[sampleKey].name);
            }
        });
        return reverseMap(titles);
    }

    const titles = createTitleList(patternList, samples);
    const tracks = createTracks(patternList, samples);
    urls = Object.fromEntries(tracks);
    const reversed = {};
    Object.keys(urls).reverse().forEach((key, index) => {
        reversed[index] = urls[key];
    });


    let rows = tracks.size;
    let keys;
    const addTriggerEvent = (keys, event) => {
        keys.player(event.detail.row).start(event.detail.time, 0, subdivision);
    }

    const loadTracks = (tracks) => {
        urls = reversed;
        //console.log(urls);
        return new Tone.Players({
            urls: urls,
            fadeOut: "64n"
        }).toDestination();
    }

    function createMatrix(patternList, columns) {
        // Initialize your matrix with 'false'
        let sequenceList = patternList[0].patternList;
        const matrix = Array(columns).fill().map(() => Array(sequenceList.length).fill(false));
        sequenceList.forEach((pattern, columnIndex) => {
            pattern.notes[0].forEach(noteIndex => {
                // Check if noteIndex is within matrix bounds
                if (noteIndex < columns) {   // Adjust this as per your requirements
                    matrix[noteIndex][columnIndex] = true;
                }
            });
        });
        return matrix;
//        return matrix.reverse();
    }

    const createPatternMatrix = (patternList, rows) => {
        // Initialize your matrix with 'false'
        let sequenceList = patternList[0].patternList;
        const matrix = Array(rows).fill().map(() => Array(sequenceList.length).fill([]));
        sequenceList.forEach((pattern, columnIndex) => {
            matrix[columnIndex] = pattern.notes;
        });
        return matrix;
    }
    const patternMatrix = createPatternMatrix(patternList, rows);
    // Use the function
    const matrix = createMatrix(patternList, columns);

    onMount(() => {
        keys = loadTracks(tracks);
//        console.log(keys);
    })

    function handleStart() {
        console.log('Transport started');
        // handle the start event
    }

    function handleStop() {
        console.log('Transport stopped');
        // handle the stop event
    }

</script>

<main>
    <ToneLoader/>
    <LavaLogo/>
    <div class="controls">
        <TonePlayToogle on:start={handleStart} on:stop={handleStop}/>
        <ToneSlider label="tempo" units="bpm" min="60" max="240" value={value}></ToneSlider>
    </div>
    <StepSequencer on:trigger={(event) => addTriggerEvent(keys, event)} columns={columns} rows={rows} urls={urls}
                   subdivision="{subdivision}" matrix="{matrix}" titles="{titles}"
                   patternmatrix="{patternMatrix}"></StepSequencer>
</main>

<style lang="scss">
  @use "theme/_smui-theme.scss";

  main {
    display: grid;
    grid-template-columns: repeat(12, [col-start] 1fr);
    gap: 20px;
  }
  .controls {
    display: grid;
    grid-column: col-start 3 / span 8;

  }

</style>